/* Crochuito – site-wide motion & interactions (v6) */
(function () {
  'use strict';
  if (window.CS) return;
  var d = document, de = d.documentElement, w = window;
  var reduce = w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = w.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var design = !!(w.Shopify && w.Shopify.designMode);
  var root = (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/';
  var T = function (k, fb) { return (w.CS_I18N && w.CS_I18N[k]) || fb; };
  var hasIO = 'IntersectionObserver' in w;
  var vh = w.innerHeight, vw = w.innerWidth;
  de.classList.add('cs-ready');
  if (design) de.classList.add('shopify-design-mode');

  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }

  /* ---------- split text into animatable words ---------- */
  function split(el) {
    if (el.hasAttribute('data-cs-split-done')) return;
    var i = 0;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          if (!n.textContent.trim()) return;
          var frag = d.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(d.createTextNode(' ')); return; }
            var o = d.createElement('span'); o.className = 'cs-w';
            var inner = d.createElement('span'); inner.className = 'cs-w__i';
            inner.style.setProperty('--wi', i++); inner.textContent = part;
            o.appendChild(inner); frag.appendChild(o);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1) {
          if (n.hasAttribute('data-cs-nosplit')) n.style.setProperty('--wi', i++);
          else if (n.tagName !== 'BR') walk(n);
        }
      });
    })(el);
    el.setAttribute('data-cs-split-done', '');
  }

  /* ---------- reveal on scroll ---------- */
  var io = hasIO ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;

  function observeReveal(scope) {
    $$('[data-cs-split], [data-cs-scrub]', scope).forEach(split);
    $$('[data-cs-reveal], [data-cs-split], [data-cs-observe]', scope).forEach(function (el) {
      if (el.classList.contains('is-visible') || el.closest('[data-cs-wait]')) return;
      if (!io || reduce) el.classList.add('is-visible'); else io.observe(el);
    });
  }

  /* ---------- intro curtain + hero ---------- */
  function liveHero() {
    $$('[data-cs-hero]').forEach(function (h) {
      h.removeAttribute('data-cs-wait');
      h.classList.add('is-live');
      observeReveal(h);
    });
  }
  function initIntro() {
    var intro = d.querySelector('[data-cs-intro]');
    var active = intro && !de.classList.contains('cs-intro-done') && !reduce && !design;
    if (!active) {
      if (intro && intro.parentNode) intro.parentNode.removeChild(intro);
      de.classList.add('cs-intro-done');
      liveHero();
      return;
    }
    $$('[data-cs-hero]').forEach(function (h) { h.setAttribute('data-cs-wait', ''); });
    var started = false, removed = false;
    function start() { if (started) return; started = true; liveHero(); }
    function remove() {
      if (removed) return; removed = true; start();
      de.classList.add('cs-intro-done');
      if (intro.parentNode) intro.parentNode.removeChild(intro);
    }
    intro.addEventListener('click', function () { de.classList.add('cs-intro-skip'); start(); });
    intro.addEventListener('animationend', function (e) { if (e.target === intro) remove(); });
    setTimeout(start, 1950);
    setTimeout(remove, 4200);
  }

  /* ---------- scroll engine ---------- */
  var bar, parallax = [], scrubs = [], hscrolls = [], stacks = [], makes = [], stages = [], anats = [];
  var lastY = w.scrollY, velocity = 0, ticking = false;

  function collect() {
    parallax = $$('[data-cs-speed]');
    scrubs = $$('[data-cs-scrub]').map(function (el) { return { el: el, words: $$('.cs-w__i', el), on: -1 }; });
    hscrolls = $$('[data-cs-hscroll]').map(function (pin) {
      return { pin: pin, track: pin.querySelector('[data-cs-track]'), viewport: pin.querySelector('[data-cs-viewport]'), dist: 0 };
    }).filter(function (h) { return h.track && h.viewport; });
    stacks = $$('[data-cs-stack]');
    makes = $$('.cs-make');
    stages = $$('[data-cs-hero-stage]').map(function (el) { return { el: el, hero: el.closest('[data-cs-hero]') || el, start: 0 }; });
    anats = $$('[data-cs-anat]').map(function (sec) {
      var steps = $$('.cs-anat__step', sec);
      return {
        sec: sec, track: sec.querySelector('[data-cs-anat-track]'), cam: sec.querySelector('[data-cs-anat-cam]'),
        steps: steps, ticks: $$('.cs-anat__ticks i', sec), active: -2,
        keys: steps.map(function (st) {
          return { z: parseFloat(st.getAttribute('data-zoom')) || 1, x: (parseFloat(st.getAttribute('data-x')) || 50) / 100, y: (parseFloat(st.getAttribute('data-y')) || 50) / 100 };
        })
      };
    }).filter(function (a) { return a.track && a.cam && a.steps.length; });
    measure();
  }

  function measure() {
    vh = w.innerHeight; vw = w.innerWidth;
    hscrolls.forEach(function (h) {
      var pinned = vw >= 990 && !reduce && !design;
      h.pin.classList.toggle('is-pinned', pinned);
      if (!pinned) { h.pin.style.height = ''; h.track.style.transform = ''; h.dist = 0; return; }
      h.dist = Math.max(0, h.track.scrollWidth - h.viewport.clientWidth);
      h.pin.style.height = (h.dist + vh) + 'px';
    });
    stages.forEach(function (s) { s.start = Math.max(1, s.el.getBoundingClientRect().top + w.scrollY); });
    anats.forEach(function (a) {
      var live = !reduce && !design;
      a.sec.classList.toggle('is-live', live);
      if (!live) { a.cam.style.transform = ''; a.sec.style.removeProperty('--fs'); a.steps.forEach(function (st) { st.classList.add('is-active'); }); }
    });
    var f = d.querySelector('body > footer');
    if (f) de.classList.toggle('cs-footer-reveal', vw >= 750 && f.offsetHeight > 0 && f.offsetHeight < vh * 0.92);
    requestTick();
  }

  function update() {
    ticking = false;
    var y = w.scrollY;
    velocity = y - lastY; lastY = y;
    var max = de.scrollHeight - vh;
    if (bar) bar.style.setProperty('--cs-p', max > 0 ? (y / max).toFixed(4) : 0);
    if (reduce) return;
    var i, r;
    for (i = 0; i < stages.length; i++) {
      stages[i].hero.style.setProperty('--hp', clamp(y / stages[i].start, 0, 1).toFixed(4));
    }
    for (i = 0; i < parallax.length; i++) {
      var el = parallax[i];
      r = el.getBoundingClientRect();
      var prev = el._py || 0, top = r.top - prev;
      if (top + r.height < -300 || top > vh + 300) continue;
      var speed = parseFloat(el.getAttribute('data-cs-speed')) || 0.1;
      var py = -((top + r.height / 2) - vh / 2) * speed;
      el._py = py;
      el.style.setProperty('--cs-py', py.toFixed(1) + 'px');
    }
    scrubs.forEach(function (s) {
      r = s.el.getBoundingClientRect();
      var start = vh * 0.88, end = vh * 0.42;
      var p = clamp((start - r.top) / (r.height + start - end), 0, 1);
      var n = Math.round(p * s.words.length);
      if (n !== s.on) { s.words.forEach(function (wd, k) { wd.classList.toggle('is-on', k < n); }); s.on = n; }
    });
    hscrolls.forEach(function (h) {
      if (!h.dist) return;
      r = h.pin.getBoundingClientRect();
      var p = clamp(-r.top / h.dist, 0, 1);
      h.track.style.transform = 'translate3d(' + (-p * h.dist).toFixed(1) + 'px,0,0)';
      h.pin.style.setProperty('--cs-hp', p.toFixed(4));
    });
    for (i = 0; i < stacks.length - 1; i++) {
      var a = stacks[i].getBoundingClientRect(), b = stacks[i + 1].getBoundingClientRect();
      var cover = clamp((a.top + stacks[i].offsetHeight - b.top) / stacks[i].offsetHeight, 0, 1);
      stacks[i].style.setProperty('--cs-cover', cover.toFixed(3));
    }
    makes.forEach(function (m) {
      var steps = m.querySelector('.cs-make__steps');
      if (!steps) return;
      r = steps.getBoundingClientRect();
      m.style.setProperty('--cs-mp', clamp((vh * 0.5 - r.top) / r.height, 0, 1).toFixed(3));
    });
    anats.forEach(updateAnat);
  }

  /* ---------- close-up: the camera moves from detail to detail while the stage is pinned ---------- */
  function ease(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  function updateAnat(a) {
    if (!a.sec.classList.contains('is-live')) return;
    var r = a.track.getBoundingClientRect();
    if (r.bottom < -50 || r.top > vh + 50) return;
    var n = a.keys.length, dist = Math.max(1, r.height - vh);
    var sp = clamp(-r.top / dist, 0, 1) * n;
    var pts = [{ t: 0, z: 1, x: 0.5, y: 0.5 }];
    a.keys.forEach(function (k, i) { pts.push({ t: i + 0.5, z: k.z, x: k.x, y: k.y }); });
    pts.push({ t: n, z: 1, x: 0.5, y: 0.5 });
    var j = 0;
    while (j < pts.length - 2 && sp > pts[j + 1].t) j++;
    var A = pts[j], B = pts[j + 1];
    var e = ease(clamp((sp - A.t) / Math.max(0.0001, B.t - A.t), 0, 1));
    var z = A.z + (B.z - A.z) * e, x = A.x + (B.x - A.x) * e, y = A.y + (B.y - A.y) * e;
    var lim = (z - 1) / 2;
    var tx = clamp(-(x - 0.5) * z, -lim, lim) * 100, ty = clamp(-(y - 0.5) * z, -lim, lim) * 100;
    a.cam.style.transform = 'translate3d(' + tx.toFixed(3) + '%,' + ty.toFixed(3) + '%,0) scale(' + z.toFixed(4) + ')';
    a.sec.style.setProperty('--fs', (0.84 + 0.16 * ease(clamp(sp / 0.5, 0, 1))).toFixed(4));
    var act = sp < 0.15 ? -1 : clamp(Math.floor(sp), 0, n - 1);
    if (act !== a.active) {
      a.steps.forEach(function (st, k) { st.classList.toggle('is-active', k === act); });
      a.active = act;
    }
    a.ticks.forEach(function (t, k) { t.style.setProperty('--t', clamp(sp - k, 0, 1).toFixed(3)); });
  }
  function requestTick() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }

  /* ---------- making-of: active step ---------- */
  function initMaking(scope) {
    $$('.cs-make', scope).forEach(function (sec) {
      if (sec._mk) return; sec._mk = 1;
      var steps = $$('.cs-step', sec), frames = $$('.cs-make__frame', sec), count = sec.querySelector('[data-cs-count]');
      if (!steps.length) return;
      function activate(i) {
        steps.forEach(function (s, j) { s.classList.toggle('is-active', j === i); });
        frames.forEach(function (f, j) { f.classList.toggle('is-active', j === i); });
        if (count) count.textContent = String(i + 1).padStart(2, '0') + ' / ' + String(steps.length).padStart(2, '0');
      }
      activate(0);
      if (!hasIO) return;
      var o = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) activate(steps.indexOf(e.target)); });
      }, { rootMargin: '-45% 0px -45% 0px' });
      steps.forEach(function (s) { o.observe(s); });
    });
  }

  /* ---------- marquee reacting to scroll speed ---------- */
  function initMarquee(scope) {
    $$('[data-cs-marquee]', scope).forEach(function (m) {
      if (m._mq || reduce) return; m._mq = 1;
      var track = m.querySelector('.cs-marquee__track'), group = track && track.firstElementChild;
      if (!group || !hasIO) return;
      var x = 0, dir = 1, mv = 0, visible = false, raf = 0, gw = group.getBoundingClientRect().width;
      var base = parseFloat(m.getAttribute('data-speed')) || 1;
      w.addEventListener('resize', function () { gw = group.getBoundingClientRect().width; });
      function step() {
        if (!visible) { raf = 0; return; }
        mv += (velocity - mv) * 0.12; velocity *= 0.9;
        if (mv > 0.4) dir = 1; else if (mv < -0.4) dir = -1;
        x -= (base * 0.7 + Math.min(Math.abs(mv) * 0.35, 16)) * dir;
        if (x <= -gw) x += gw;
        if (x > 0) x -= gw;
        track.style.transform = 'translate3d(' + x.toFixed(2) + 'px,0,0)';
        raf = requestAnimationFrame(step);
      }
      new IntersectionObserver(function (es) {
        visible = es[0].isIntersecting;
        if (visible && !raf) raf = requestAnimationFrame(step);
      }).observe(m);
    });
  }

  /* ---------- toast ---------- */
  var toastEl, toastT;
  function toast(msg, withLink) {
    if (!toastEl) { toastEl = d.createElement('div'); toastEl.className = 'cs-toast'; toastEl.setAttribute('role', 'status'); d.body.appendChild(toastEl); }
    toastEl.textContent = '';
    var s = d.createElement('span'); s.textContent = msg; toastEl.appendChild(s);
    if (withLink) { var a = d.createElement('a'); a.href = root + 'cart'; a.textContent = T('view_cart', 'View cart'); toastEl.appendChild(a); }
    requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 4200);
  }

  /* ---------- add to basket without leaving the page ---------- */
  function setLabel(btn, state) {
    var l = btn.querySelector('[data-cs-add-label]');
    if (!l) return;
    if (!l.hasAttribute('data-orig')) l.setAttribute('data-orig', l.textContent);
    l.textContent = state === 'added' ? (btn.getAttribute('data-label-added') || 'Added') : l.getAttribute('data-orig');
  }
  d.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-cs-add]')) return;
    e.preventDefault();
    var btns = [e.submitter, form.querySelector('[type="submit"]')];
    if (form.id) btns = btns.concat($$('[type="submit"][form="' + form.id + '"]'));
    btns = btns.filter(function (b, k) { return b && btns.indexOf(b) === k; });
    btns.forEach(function (b) { b.classList.add('is-loading'); b.disabled = true; });
    var done = function () { btns.forEach(function (b) { b.classList.remove('is-loading'); b.disabled = false; }); };
    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || T('error', 'Something went wrong')); return j; }); })
      .then(function (item) {
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) { return { item: item, cart: cart }; });
      })
      .then(function (res) {
        done();
        d.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: res.cart, sourceId: 'cs-add', data: { itemCount: res.cart.item_count, source: 'cs-add' } } }));
        d.dispatchEvent(new CustomEvent('cs:added', { detail: res }));
        btns.forEach(function (b) {
          b.classList.add('is-added'); setLabel(b, 'added');
          setTimeout(function () { b.classList.remove('is-added'); setLabel(b, 'reset'); }, 2200);
        });
        var drawer = d.querySelector('cart-drawer-component');
        if (d.querySelector('[data-cs-cart]')) { /* the Crochuito cart (slide-over or cart page) updates and opens itself */ }
        else if (drawer && typeof drawer.open === 'function') setTimeout(function () { drawer.open(); }, 380);
        else toast(T('added', '[item] added to cart').replace('[item]', res.item && res.item.product_title ? res.item.product_title : T('item', 'Item')), true);
      })
      .catch(function (err) { done(); toast(err && err.message ? err.message : T('failed', 'Could not add this item'), false); });
  });

  /* ---------- product page ---------- */
  function initPDP(scope) {
    $$('[data-cs-product]', scope).forEach(function (sec) {
      if (sec._pdp) return; sec._pdp = 1;
      var slides = $$('.cs-pdp__slide', sec), thumbs = $$('.cs-pdp__thumb', sec), counter = sec.querySelector('[data-cs-current]');
      function setActive(i) {
        if (i < 0) return;
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
        if (counter) counter.textContent = i + 1;
      }
      var hgal = sec.hasAttribute('data-cs-hgallery');
      function goTo(k) {
        var s = slides[k]; if (!s) return;
        if (hgal) { var track = s.parentNode; track.scrollTo({ left: track.scrollLeft + s.getBoundingClientRect().left - track.getBoundingClientRect().left, behavior: reduce ? 'auto' : 'smooth' }); return; }
        if (vw < 990) s.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest', inline: 'start' });
        else s.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      }
      if (hasIO && slides.length > 1) {
        var sio = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) setActive(slides.indexOf(e.target)); });
        }, { threshold: 0.6 });
        slides.forEach(function (s) { sio.observe(s); });
      }
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { setActive(k); goTo(k); }); });
      if (fine) slides.forEach(function (s) {
        function pos(e) {
          var r = s.getBoundingClientRect();
          s.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
          s.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
        }
        s.addEventListener('click', function (e) { if (vw < 990) return; pos(e); s.classList.toggle('is-zoomed'); });
        s.addEventListener('pointermove', function (e) { if (s.classList.contains('is-zoomed')) pos(e); });
        s.addEventListener('pointerleave', function () { s.classList.remove('is-zoomed'); });
      });

      var variants = [];
      var dataEl = sec.querySelector('[data-cs-variants]');
      try { variants = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (err) { variants = []; }
      var idInput = sec.querySelector('[data-cs-variant-id]'), priceEl = sec.querySelector('[data-cs-price]');
      var addBtns = $$('[data-cs-add-btn]', sec), barPrice = sec.querySelector('[data-cs-bar-price]');
      var groups = $$('[data-cs-opt-group]', sec);
      function selected() { return groups.map(function (g) { var b = g.querySelector('[aria-pressed="true"]'); return b ? b.getAttribute('data-value') : null; }); }
      function match(sel) {
        for (var k = 0; k < variants.length; k++) {
          var v = variants[k], ok = true;
          for (var j = 0; j < sel.length; j++) if (v.options[j] !== sel[j]) { ok = false; break; }
          if (ok) return v;
        }
        return null;
      }
      function marks() {
        groups.forEach(function (g, gi) {
          $$('.cs-opt', g).forEach(function (b) {
            var sel = selected(); sel[gi] = b.getAttribute('data-value');
            var m = match(sel);
            b.classList.toggle('is-unavailable', !m || !m.available);
          });
        });
      }
      function apply(v) {
        if (idInput) idInput.value = v.id;
        if (priceEl) {
          priceEl.textContent = v.price;
          if (v.compare) { var s = d.createElement('s'); s.textContent = v.compare; priceEl.appendChild(s); }
        }
        if (barPrice) barPrice.textContent = v.price;
        addBtns.forEach(function (btn) {
          btn.disabled = !v.available;
          var l = btn.querySelector('[data-cs-add-label]');
          if (l) { l.textContent = v.available ? btn.getAttribute('data-label-add') : btn.getAttribute('data-label-soldout'); l.removeAttribute('data-orig'); }
        });
        marks();
        if (v.media) {
          var idx = -1;
          slides.forEach(function (s, k) { if (s.getAttribute('data-media-id') === String(v.media)) idx = k; });
          if (idx > -1) { setActive(idx); goTo(idx); }
        }
        if (sec.hasAttribute('data-cs-no-url')) return;
        try { var u = new URL(w.location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString()); } catch (err) {}
      }
      groups.forEach(function (g) {
        g.addEventListener('click', function (e) {
          var b = e.target.closest('.cs-opt'); if (!b) return;
          $$('.cs-opt', g).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          var v = match(selected()); if (v) apply(v);
        });
      });
      if (groups.length) marks();

      $$('[data-cs-qty]', sec).forEach(function (b) {
        b.addEventListener('click', function () {
          var input = b.parentNode.querySelector('input');
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-cs-qty'), 10));
        });
      });

      var barEl = sec.querySelector('[data-cs-bar]'), main = sec.querySelector('.cs-pdp__add');
      if (barEl && main && hasIO) new IntersectionObserver(function (es) {
        var e = es[0];
        barEl.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(main);
    });
  }

  /* ---------- smooth accordions ---------- */
  function initAcc(scope) {
    $$('.cs-acc details', scope).forEach(function (det) {
      if (det._acc) return; det._acc = 1;
      var sum = det.querySelector('summary');
      if (!sum) return;
      sum.addEventListener('click', function (e) {
        if (reduce || !det.animate) return;
        e.preventDefault();
        if (det._anim) { det._anim.cancel(); det._anim = null; }
        var start = det.offsetHeight, opts = { duration: 480, easing: 'cubic-bezier(.2,.7,.2,1)' };
        if (!det.open) {
          det.open = true;
          var end = det.offsetHeight;
          det._anim = det.animate({ height: [start + 'px', end + 'px'] }, opts);
          det._anim.onfinish = function () { det._anim = null; };
        } else {
          var closed = sum.offsetHeight + (det.offsetHeight - det.clientHeight);
          det._anim = det.animate({ height: [start + 'px', closed + 'px'] }, opts);
          det._anim.onfinish = function () { det.open = false; det._anim = null; };
        }
      });
    });
  }

  /* ---------- horizontal rails (drag + arrows) and mobile gallery progress ---------- */
  function initRails(scope) {
    $$('[data-cs-railx]', scope).forEach(function (rail) {
      if (rail._r) return; rail._r = 1;
      var nav = rail.id ? d.querySelector('[data-cs-railnav="' + rail.id + '"]') : null;
      if (nav) $$('button', nav).forEach(function (b) {
        b.addEventListener('click', function () {
          rail.scrollBy({ left: (b.getAttribute('data-dir') === 'prev' ? -1 : 1) * rail.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
        });
      });
      if (!fine) return;
      var down = false, moved = false, sx = 0, sl = 0;
      rail.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse' || e.button !== 0) return; down = true; moved = false; sx = e.clientX; sl = rail.scrollLeft; });
      w.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - sx;
        if (!moved && Math.abs(dx) > 6) { moved = true; rail.classList.add('is-dragging'); }
        if (moved) rail.scrollLeft = sl - dx;
      });
      w.addEventListener('pointerup', function () { if (!down) return; down = false; setTimeout(function () { rail.classList.remove('is-dragging'); }, 30); });
      rail.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      rail.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
    $$('[data-cs-hscroll]', scope).forEach(function (pin) {
      var vp = pin.querySelector('[data-cs-viewport]');
      if (!vp || vp._sp) return; vp._sp = 1;
      vp.addEventListener('scroll', function () {
        if (pin.classList.contains('is-pinned')) return;
        var m = vp.scrollWidth - vp.clientWidth;
        pin.style.setProperty('--cs-hp', m > 0 ? (vp.scrollLeft / m).toFixed(4) : 0);
      }, { passive: true });
    });
  }

  /* ---------- chapter dots (long pages) ---------- */
  var chapterIO;
  function initChapters() {
    var old = d.querySelector('.cs-rail'); if (old) old.remove();
    var chapters = $$('[data-cs-chapter]').filter(function (c) { return c.id; });
    if (chapters.length < 4 || !hasIO) return;
    var rail = d.createElement('nav'); rail.className = 'cs-rail'; rail.setAttribute('aria-label', T('chapters', 'Page chapters'));
    chapters.forEach(function (c) {
      var a = d.createElement('a'); a.href = '#' + c.id; a.innerHTML = '<span></span><i></i>';
      a.querySelector('span').textContent = c.getAttribute('data-cs-chapter');
      a.addEventListener('click', function (ev) { ev.preventDefault(); c.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' }); });
      rail.appendChild(a);
    });
    d.body.appendChild(rail);
    var links = $$('a', rail);
    if (chapterIO) chapterIO.disconnect();
    chapterIO = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var i = chapters.indexOf(e.target);
        links.forEach(function (l, j) { l.classList.toggle('is-active', j === i); });
        rail.classList.toggle('is-on', i > 0);
      });
    }, { rootMargin: '-50% 0px -50% 0px' });
    chapters.forEach(function (c) { chapterIO.observe(c); });
  }

  /* ---------- money + free shipping (shipping bar and cart progress, live) ---------- */
  var SHOP = w.CS_SHOP || {};
  function decode(s) { var t = d.createElement('textarea'); t.innerHTML = s; return t.value; }
  function money(cents, trim) {
    var format = decode(SHOP.money || '€{{amount_with_comma_separator}}');
    var re = /\{\{\s*(\w+)\s*\}\}/, m = format.match(re), key = m ? m[1] : 'amount';
    function fmt(dec, ts, ds) {
      var n = (cents / 100).toFixed(dec).split('.');
      var i = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return n[1] ? i + ds + n[1] : i;
    }
    var v;
    switch (key) {
      case 'amount_no_decimals': v = fmt(0, ',', '.'); break;
      case 'amount_with_comma_separator': v = fmt(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(2, "'", '.'); break;
      default: v = fmt(2, ',', '.');
    }
    if (trim) v = v.replace(/[.,]00$/, '');
    return format.replace(re, v);
  }
  function applyTotal(total) {
    var from = SHOP.freeFrom || 0;
    if (!from || typeof total !== 'number') return;
    var rem = from - total, p = total <= 0 ? 0 : Math.min(1, total / from);
    var state = total <= 0 ? 'idle' : rem > 0 ? 'more' : 'done';
    var text = state === 'more' ? T('fs_more', '[amount] more for free shipping').replace('[amount]', money(rem))
      : state === 'done' ? T('fs_done', 'This order ships free')
      : T('fs_threshold', 'Free shipping on orders over [amount]').replace('[amount]', money(from, true));
    $$('[data-cs-shipbar]').forEach(function (bar) {
      bar.classList.remove('cs-shipbar--idle', 'cs-shipbar--more', 'cs-shipbar--done');
      bar.classList.add('cs-shipbar--' + state);
      bar.style.setProperty('--fs', state === 'idle' ? 0 : p.toFixed(4));
      var msg = bar.querySelector('[data-cs-shipbar-msg]');
      if (msg && msg.textContent !== text) msg.textContent = text;
    });
    $$('[data-cs-fs]').forEach(function (fs) {
      fs.classList.toggle('is-done', rem <= 0);
      fs.style.setProperty('--p', p.toFixed(4));
      var t = fs.querySelector('[data-cs-fs-text]');
      if (t && state !== 'idle') t.textContent = text;
      var b = fs.querySelector('[data-cs-fs-bar]');
      if (b) b.setAttribute('aria-valuenow', Math.round(p * 100));
    });
  }
  d.addEventListener('cart:update', function (e) {
    var c = e.detail && e.detail.resource;
    if (c && typeof c.total_price === 'number') { applyTotal(c.total_price); return; }
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { applyTotal(cart.total_price); })
      .catch(function () {});
  });

  /* ---------- shop: price and stock filters, sorting (cards glide to their new place) ---------- */
  function initShop(scope) {
    $$('[data-cs-shop]', scope).forEach(function (sec) {
      if (sec._shop) return; sec._shop = 1;
      var grid = sec.querySelector('[data-cs-grid]'), bar = sec.querySelector('[data-cs-filters]');
      if (!grid || !bar) return;
      var items = $$('[data-cs-item]', grid);
      var chips = $$('[data-cs-price]', bar), stock = bar.querySelector('[data-cs-instock]'), sort = bar.querySelector('[data-cs-sort]');
      var countEl = sec.querySelector('[data-cs-count]'), empty = sec.querySelector('[data-cs-empty]'), clear = sec.querySelector('[data-cs-clear]');
      var state = { range: 'all', stock: false, sort: 'featured' };
      if (countEl && countEl.parentNode) countEl.parentNode.setAttribute('aria-live', 'polite');
      function num(el, k) { return parseFloat(el.getAttribute('data-' + k)) || 0; }
      function inRange(price) {
        if (state.range === 'all') return true;
        var b = state.range.split('-'), lo = parseFloat(b[0]) || 0, hi = b[1] ? parseFloat(b[1]) : Infinity;
        return price >= lo && price < hi;
      }
      function apply() {
        var first = [];
        items.forEach(function (it) { if (!it.hidden) first.push([it, it.getBoundingClientRect()]); });
        var shown = items.filter(function (it) {
          return inRange(num(it, 'price')) && (!state.stock || it.getAttribute('data-available') === 'true');
        });
        var order = items.slice().sort(function (a, b) {
          var ia = num(a, 'index'), ib = num(b, 'index');
          if (state.sort === 'price-asc') return (num(a, 'price') - num(b, 'price')) || (ia - ib);
          if (state.sort === 'price-desc') return (num(b, 'price') - num(a, 'price')) || (ia - ib);
          return ia - ib;
        });
        order.forEach(function (it) { grid.appendChild(it); });
        items.forEach(function (it) {
          var on = shown.indexOf(it) > -1;
          it.hidden = !on;
          if (on) it.classList.add('is-visible');
        });
        if (!reduce && grid.animate) {
          shown.forEach(function (it) {
            var f = null;
            for (var k = 0; k < first.length; k++) if (first[k][0] === it) { f = first[k][1]; break; }
            var l = it.getBoundingClientRect();
            if (f) {
              var dx = f.left - l.left, dy = f.top - l.top;
              if (Math.abs(dx) > 1 || Math.abs(dy) > 1) it.animate([{ transform: 'translate(' + dx + 'px,' + dy + 'px)' }, { transform: 'none' }], { duration: 560, easing: 'cubic-bezier(.2,.7,.2,1)' });
            } else {
              it.animate([{ opacity: 0, transform: 'translateY(16px) scale(.97)' }, { opacity: 1, transform: 'none' }], { duration: 480, easing: 'cubic-bezier(.2,.7,.2,1)' });
            }
          });
        }
        if (countEl) countEl.textContent = shown.length;
        if (empty) empty.hidden = shown.length > 0;
      }
      chips.forEach(function (c) {
        c.addEventListener('click', function () {
          state.range = c.getAttribute('data-cs-price');
          chips.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
          apply();
        });
      });
      if (stock) stock.addEventListener('change', function () { state.stock = stock.checked; apply(); });
      if (sort) sort.addEventListener('change', function () { state.sort = sort.value; apply(); });
      if (clear) clear.addEventListener('click', function () {
        state.range = 'all'; state.stock = false;
        if (stock) stock.checked = false;
        chips.forEach(function (x) { x.setAttribute('aria-pressed', x.getAttribute('data-cs-price') === 'all' ? 'true' : 'false'); });
        apply();
      });
    });
  }

  /* ---------- quick view (product loaded with the Section Rendering API) ---------- */
  var qvd, qvBody, qvLast, qvCtrl, qvT;
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function buildQV() {
    qvd = d.createElement('dialog');
    qvd.className = 'cs cs-qvd';
    qvd.setAttribute('aria-labelledby', 'cs-qv-title');
    qvd.innerHTML = '<div class="cs-qvd__wrap"><div class="cs-qvd__panel">' +
      '<button type="button" class="cs-qvd__close" aria-label="' + esc(T('close', 'Close')) + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button>' +
      '<div class="cs-qvd__body" data-cs-qv-body></div></div></div>';
    d.body.appendChild(qvd);
    qvBody = qvd.querySelector('[data-cs-qv-body]');
    qvd.querySelector('.cs-qvd__close').addEventListener('click', closeQV);
    qvd.addEventListener('click', function (e) { if (e.target === qvd || e.target.classList.contains('cs-qvd__wrap')) closeQV(); });
    qvd.addEventListener('cancel', function (e) { e.preventDefault(); closeQV(); });
  }
  function openQV(url, trigger) {
    if (!qvd) buildQV();
    clearTimeout(qvT);
    qvLast = trigger;
    qvBody.innerHTML = '<div class="cs-qvd__state" role="status"><span class="cs-spin" aria-hidden="true"></span><span class="cs-visually-hidden">' + esc(T('loading', 'Loading')) + '</span></div>';
    if (!qvd.open) { if (typeof qvd.showModal === 'function') qvd.showModal(); else qvd.setAttribute('open', ''); }
    de.classList.add('cs-qv-open');
    requestAnimationFrame(function () { requestAnimationFrame(function () { qvd.classList.add('is-open'); }); });
    if (qvCtrl) qvCtrl.abort();
    qvCtrl = 'AbortController' in w ? new AbortController() : null;
    var src = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=cs-quickview';
    fetch(src, { signal: qvCtrl ? qvCtrl.signal : undefined, headers: { Accept: 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        var tmp = d.createElement('div'); tmp.innerHTML = html;
        var content = tmp.querySelector('.cs-qv');
        if (!content) throw new Error('empty');
        qvBody.innerHTML = '';
        qvBody.appendChild(content);
        init(qvBody);
        var first = qvBody.querySelector('.cs-opt, .cs-pdp__add');
        if (first && fine) first.focus({ preventScroll: true });
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        qvBody.innerHTML = '<div class="cs-qvd__state"><p class="cs-lead">' + esc(T('qv_error', 'This product could not be loaded.')) + '</p><a class="cs-btn" href="' + esc(url) + '">' + esc(T('view_details', 'View full details')) + '</a></div>';
      });
  }
  function closeQV() {
    if (!qvd || !qvd.open) return;
    if (qvCtrl) qvCtrl.abort();
    qvd.classList.remove('is-open');
    de.classList.remove('cs-qv-open');
    qvT = setTimeout(function () {
      if (qvd.open) qvd.close();
      qvBody.innerHTML = '';
      if (qvLast && qvLast.focus && d.contains(qvLast)) qvLast.focus({ preventScroll: true });
    }, reduce ? 0 : 340);
  }
  d.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cs-qv]');
    if (!b) return;
    e.preventDefault();
    openQV(b.getAttribute('data-cs-qv'), b);
  });
  d.addEventListener('cs:added', function () { if (qvd && qvd.open) closeQV(); });

  /* ---------- pointer: magnetic buttons and card depth (fine pointers only) ---------- */
  function initPointer() {
    if (!fine || reduce || design) return;
    if (SHOP.depth !== false) de.classList.add('cs-depth-on');
    d.addEventListener('pointerover', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (SHOP.magnetic !== false) {
        var b = t.closest('.cs .cs-btn');
        if (b && !b._mag && !b.disabled && !b.classList.contains('cs-btn--block')) magnet(b);
      }
      if (SHOP.depth !== false) {
        var v = t.closest('[data-cs-depth]');
        if (v && !v._dp) depth(v);
      }
    });
  }
  function magnet(b) {
    b._mag = 1;
    function move(ev) {
      var r = b.getBoundingClientRect();
      var dx = clamp((ev.clientX - (r.left + r.width / 2)) * 0.22, -10, 10);
      var dy = clamp((ev.clientY - (r.top + r.height / 2)) * 0.32, -7, 7);
      b.classList.add('is-magnet');
      b.style.translate = dx.toFixed(1) + 'px ' + dy.toFixed(1) + 'px';
    }
    function leave() {
      b.classList.remove('is-magnet');
      b.style.translate = '';
      b.removeEventListener('pointermove', move);
      b.removeEventListener('pointerleave', leave);
      b._mag = 0;
    }
    b.addEventListener('pointermove', move);
    b.addEventListener('pointerleave', leave);
  }
  function depth(v) {
    v._dp = 1;
    var raf = 0, px = 0.5, py = 0.5;
    function paint() {
      raf = 0;
      v.style.setProperty('--rx', ((0.5 - py) * 5).toFixed(2) + 'deg');
      v.style.setProperty('--ry', ((px - 0.5) * 6).toFixed(2) + 'deg');
      v.style.setProperty('--gx', (px * 100).toFixed(1) + '%');
      v.style.setProperty('--gy', (py * 100).toFixed(1) + '%');
    }
    function move(ev) {
      var r = v.getBoundingClientRect();
      px = clamp((ev.clientX - r.left) / r.width, 0, 1);
      py = clamp((ev.clientY - r.top) / r.height, 0, 1);
      v.classList.add('is-tilting');
      if (!raf) raf = requestAnimationFrame(paint);
    }
    function leave() {
      if (raf) cancelAnimationFrame(raf);
      raf = 0;
      v.classList.remove('is-tilting');
      v.style.setProperty('--rx', '0deg');
      v.style.setProperty('--ry', '0deg');
      v.removeEventListener('pointermove', move);
      v.removeEventListener('pointerleave', leave);
      v._dp = 0;
    }
    v.addEventListener('pointermove', move);
    v.addEventListener('pointerleave', leave);
  }

  /* ---------- boot ---------- */
  function init(scope) {
    scope = scope || d;
    initMaking(scope); initMarquee(scope); initPDP(scope); initAcc(scope); initRails(scope); initShop(scope);
    observeReveal(scope);
    collect();
  }
  function boot() {
    bar = d.createElement('div'); bar.className = 'cs-progress'; bar.setAttribute('aria-hidden', 'true');
    d.body.appendChild(bar);
    initIntro();
    init(d);
    initChapters();
    initPointer();
    update();
  }
  w.CS = { refresh: function (scope) { init(scope || d); initChapters(); } };
  w.addEventListener('scroll', requestTick, { passive: true });
  w.addEventListener('resize', function () { measure(); });
  w.addEventListener('load', function () { measure(); });
  if (d.fonts && d.fonts.ready) d.fonts.ready.then(function () { measure(); });
  w.addEventListener('pageshow', function (e) { if (e.persisted) measure(); });
  d.addEventListener('shopify:section:load', function (e) { init(e.target); initChapters(); });
  d.addEventListener('shopify:section:unload', function () { setTimeout(function () { collect(); initChapters(); }, 60); });
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})();
